import { createSlice } from "@reduxjs/toolkit";
import { fundRaiserViewDetailAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const fundRaiserViewDetailSlice = createSlice({
  name: "fundRaiserViewDetail",
  initialState: data,
  reducers: {
    fundRaiserViewDetailSlice(state) {
      state.isLoading = true;
    },
    fundRaiserViewDetailSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = null;
    },
    fundRaiserViewDetailSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    fundRaiserViewDetailSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const fundRaiserViewDetailHandler = (id: string) => async (dispatch: any) => {
  try {
    dispatch(fundRaiserViewDetailAction.fundRaiserViewDetailSlice());
    const response: any = await fundRaiserViewDetailAPI(id);
    dispatch(fundRaiserViewDetailAction.fundRaiserViewDetailSliceSuccess(response));
  } catch (e: any) {
    dispatch(fundRaiserViewDetailAction.fundRaiserViewDetailSliceFailure(e?.response?.data?.message));
    dispatch(fundRaiserViewDetailAction.fundRaiserViewDetailSliceReset());
  }
};
export default fundRaiserViewDetailSlice.reducer;
export const fundRaiserViewDetailAction = fundRaiserViewDetailSlice.actions;
